module.exports = __webpack_public_path__ + "static/media/icon-menu.33dfb066.svg";